export default __webpack_public_path__ + "static/media/aes.998ccec7.png";